import {BaseContainerModel} from '../../base-container.model';
import { TopicMemberLabelLinkContainerModel } from './topic-member-label-link-container.model';

export class NotificationLabelTopicLinkResourceContainer extends BaseContainerModel {
  guid: string;
  event_properties: TopicMemberLabelLinkContainerModel; 
}
